import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import type { Component } from '@wix/thunderbolt-becky-types'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { isRefArray } from '../../utils/variantsUtils'

export const transformations = createCssCompNode('transformations', 'transformations', {
	getDependencies: (component: Component, refs: FeatureRefs<'transformations'>) =>
		component.transformationQuery
			? {
					transformationRefArray: refs.transformationQuery(component.transformationQuery),
					ignoredTransformProps: envRefs.compIdToIgnoredTransformProps(component.id),
					globalIgnoredTransformProps: envRefs.globalIgnoredTransformProps,
					viewMode: envRefs.viewMode,
			  }
			: null,
	toViewItem: (component, data) => {
		if (!data || !isRefArray(data.transformationRefArray)) {
			return null
		}

		const { transformationRefArray, ignoredTransformProps, globalIgnoredTransformProps, viewMode } = data
		const breakpointToTransformation = toBreakpointVariantsMap(transformationRefArray.values, (x) => x)

		return {
			breakpointToTransformation,
			ignoredTransformProps: ignoredTransformProps ?? (globalIgnoredTransformProps || []),
			...(component.layout && { defaultRotationInDegrees: component.layout.rotationInDegrees }),
			isMobile: viewMode === 'mobile',
		}
	},
})
